import { connect } from 'react-redux'
import { initForm, saveForm, undoChange, redoChange, moveRowItem, addRowItem, updateRowItem, deleteRowItem,
  updateCellItem, updateElementItem, deleteElementItem, moveElementItem, updateFormAttrs
} from 'actions/form_builder_actions'

export default connect((state) => ({
  data: state.formBuilder?.present?.data || {},
  counters: {
    past: state.formBuilder?.past?.length || 0,
    future: state.formBuilder?.future?.length || 0
  },
  url: state.formBuilder?.present?.url
}), { initForm, saveForm, undoChange, redoChange, moveRowItem, addRowItem, updateRowItem, deleteRowItem,
  updateCellItem, updateElementItem, deleteElementItem, moveElementItem, updateFormAttrs
})
